import React, { Component } from 'react';

class ArkResult extends Component {
    
    componentDidUpdate(prevProps, prevState) {
        if (this.props.data !== prevProps.data) {
            //if (this.carousel !== null) this.carousel.resize();
            if (this.props.data !== undefined && this.props.data !== null) {
                this.props.toggleRealtimeAnswer(false)
            }
        }
    }

    send(value) {
        let sendData = {
            "utterance" : value, 
            "sessionKey" : this.props.sessionKey,
            "channelId" : this.props.channelId,
            "isLogin" : this.props.isLogin,
            "isDev" : this.props.config.isDev,
            "projectId" : this.props.config.projectId
        }

        this.props.send(sendData);
    }
    
    convertHL(modified) {
        let ret = modified
        if (ret.indexOf('<!HS>') > -1 ) {
            ret = modified.split('<!HS>').map (
                (tempStr, tempKey) => (
                    tempStr.indexOf('<!HE>') > -1 
                        ? tempStr.split('<!HE>').map (
                            (item, itemKey) => (
                                itemKey === 0 ? <mark className="search_keyword" key={itemKey}>{item}</mark> : <mark key={itemKey}>{item}</mark>
                            )
                        )
                        : <mark key={tempKey}>{tempStr}</mark>
                    )
                )
        }
        return ret
    }

    settingArk(value) {
        this.props.settingArk(value);
    }

    render() {
        const displayBlock = {
            display : "block",
        }

        const displayNone = {
            display : "none",
        }

        const displayInlineBlock = {
            display : "inline-block",
        }

        return (
            <div className="ly_box_bottom is_open">
                <div className="ly_box_top">
                    <strong className="ly_box_tit">{this.props.uiTexts.text_09}</strong>
                    { this.props.useArk 
                        ? <button type="button" className="btn_control is_active" onClick={()=>{{this.settingArk(false)}}}>ON</button>
                        : <button type="button" className="btn_control"  onClick={()=>{{this.settingArk(true)}}}>OFF</button>
                    }
                </div>
                <div className="auto_box" style={displayBlock}>
                    <ul className="qna_list">
                    { this.props.data !== undefined && this.props.data !== null &&
                        this.props.data.map(
                            (item, index) => (
                                <li className="qna_item" style={displayBlock} key={index}>
                                    <a href="#none" onClick={() => this.send(item.text)} className="qna_link" style={displayBlock} key={index}>{this.convertHL(item.modified)}</a>
                                </li>
                            )
                        )
                    }
                    </ul>
                </div>
            </div>
        )
   }
};

export default ArkResult;